<div class="grid-event-wrapper" [class.image]="showParticipantImage" (click)="eventClick($event)">
    <a
        class="grid-info-wrapper"
        [class.fixed]="media.enabled"
        [href]="eventUrl"
        [msRemoveHref]="shouldRemoveHref"
        [class.image]="showParticipantImage">
        <ms-event-detail
            [event]="scoreBoardEvent"
            [mediaEnabled]="media.enabled"
            [showTimeInfoOnTop]="showTimeInfoOnTop"
            [promotedFixtureIdsMap]="promotedFixtureIdsMap"
            [showParticipantImage]="showParticipantImage"></ms-event-detail>
        <ms-grid-scoreboard *ngIf="scoreBoardEvent" [event]="scoreBoardEvent"></ms-grid-scoreboard>
        <ms-fixture-form *ngIf="couponEvent.fixtureForm" [event]="couponEvent"></ms-fixture-form>
    </a>

    <ms-event-media
        *ngIf="media.enabled"
        [event]="couponEvent"
        [media]="media"
        [tracking]="tracking"
        [betBuilderEpcotEnabled]="betBuilderEpcotEnabled"
        (statsClicked)="statsClicked.emit()"></ms-event-media>
    <div class="grid-group-container" [ngClass]="{ 'btn-cta-ogp': betBuilderEpcotEnabled }">
        <ng-container *ngIf="groupTemplate; else defaultView">
            <a class="grid-option-group empty" [href]="eventUrl" [msRemoveHref]="shouldRemoveHref">
                <ng-container
                    *ngTemplateOutlet="
                        groupTemplate;
                        context: { event: couponEvent, hasPreCreated: true, betBuilderEpcotEnabled: betBuilderEpcotEnabled }
                    "></ng-container>
            </a>
        </ng-container>

        <ng-template #defaultView>
            <ng-container *ngIf="empty; else groupsView">
                <a class="grid-option-group empty" [href]="eventUrl" [msRemoveHref]="shouldRemoveHref">
                    <ms-font-resizer defaultSize="1" maxChars="emptyChars" [value]="emptyText"></ms-font-resizer>
                    <span class="theme-right"></span>
                </a>
            </ng-container>
        </ng-template>

        <ng-template #groupsView>
            <ng-container *ngFor="let group of couponGroups; trackBy: trackOptionGroup">
                <ng-container>
                    <div class="card-tennis-live">
                        <ms-odd-increment-decrement
                            [position]="0"
                            [participantScore]="scoreBoardMap[group.id + '-' + participant1Position].participantScore"
                            [participantLiveScore]="scoreBoardMap[group.id + '-' + this.participant1Position].participantLiveScore"
                            (changeScoreEvent)="changeScoreEvent($event, group.id)">
                        </ms-odd-increment-decrement>

                        <div class="grid-participant-livescore">
                            <ms-odd-increment-decrement
                                [position]="1"
                                [participantScore]="scoreBoardMap[group.id + '-' + this.participant2Position].participantScore"
                                [participantLiveScore]="scoreBoardMap[group.id + '-' + this.participant2Position].participantLiveScore"
                                (changeScoreEvent)="changeScoreEvent($event, group.id)">
                            </ms-odd-increment-decrement>
                        </div>
                    </div>
                </ng-container>
                <ms-option-group
                    [optionGroup]="groupsMap[group.id]"
                    [event]="couponEvent"
                    [group]="group"
                    [tracking]="tracking"
                    [showOptionname]="showOptionName"
                    [betDetails]="betDetails">
                </ms-option-group>
            </ng-container>
        </ng-template>
    </div>

    <a class="bets-count-button" *ngIf="hasBetsCountButton" [href]="eventUrl" [msRemoveHref]="shouldRemoveHref" (click)="trackMoreBets($event)">
        <span class="bets-count-span">{{ betsCountMessage }}</span>
        <span class="theme-right"></span>
    </a>
    <ms-favourite-event-toggle *ngIf="favouriteToggle" [event]="couponEvent" [static]="true" [tracking]="tracking"></ms-favourite-event-toggle>
</div>
